const orderColumn = [
  {
    key: 'num',
    label: 'SN.',
  },
  {
    key: 'grandTotal',
    label: 'Amount',
  },
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'userName',
    label: 'User',
  },
  {
    key: 'userPhone',
    label: 'Contact',
  },
  {
    key: 'userEmail',
    label: 'Email',
  },
  {
    key: 'totalItems',
    label: 'Total Items',
  },
  {
    key: 'orderStatus',
    label: 'status',
  },

  {
    key: 'actions',
    label: 'Actions',
  },
];
export { orderColumn };
